import React, { useCallback } from 'react';
import css from './styles.module.scss';
import { MoneyListItemDto } from '~/models/contract.dto';
import { useAppRoute } from '~/utils/hooks/useAppRoute';
import { Card, CardContent, Avatar, Grid, Typography } from '@material-ui/core';
import moment from 'moment';
import {CancelOutlined as CancelIcon } from "@material-ui/icons";
import classNames from "classnames";
interface MoneyCardProps {
    data: MoneyListItemDto;
}

export const MoneyCard: React.FC<MoneyCardProps> = ({ data }) => {
    const route = useAppRoute();
    const goToDetails = useCallback(() => route(`/creators-list/${data.projectId}/dashboard/money/${data.assetCode}/edit-deal`), [
        data.projectId,
        data.assetCode,
        route,
    ]);

    return (
        <Card className={css.module} elevation={0} onClick={goToDetails}>
            <CardContent>
                <Grid container className={css.grid}>
                    <Grid item xs={1} className={css.gridItem}>
                        <Avatar alt={data.contractTitle} src={data.contactImage || ''} />
                    </Grid>
                    <Grid item xs={5} className={css.boxTitle}>
                        <Typography className="bold">{data.contractTitle}</Typography>
                    </Grid>
                    <Grid item xs={2} className={css.boxInfo}>
                        <Typography className={css.littleText}>LAST PAYMENT</Typography>
                        <Typography className="bold">
                            {moment.utc(data.invDate) &&
                            data.invDate !== '' &&
                            data.invDate !== '1900-01-01T00:00:00' &&
                            data.invDate !== 'null' &&
                            data.invDate !== null &&
                            data.invDate !== 'Invalid date'
                                ? moment.utc(data.invDate).format('DD MMM YYYY')
                                : null}
                        </Typography>
                    </Grid>
                    <Grid item xs={2} className={css.boxInfo}>
                        <Typography className={css.littleText}>PAID</Typography>
                        {/*{data.IsPaid === 0 ? (*/}
                            <CancelIcon fontSize="small" style={{ color: 'red' }} />
                        {/*) : (*/}
                        {/*    <CheckCircleIcon fontSize="small" style={{ color: 'green' }} />*/}
                        {/*)}*/}
                    </Grid>
                    <Grid item xs={2} className={css.boxInfo}>
                        <Typography className={css.littleText}>NEXT PAYMENT</Typography>
                        <Typography className="bold">
                            {moment.utc(String(data.nextInvDate)) &&
                            data.nextInvDate !== 0 &&
                            data.nextInvDate !== 0 &&
                            data.nextInvDate !== null
                                ? moment.utc(String(data.nextInvDate)).format('DD MMM YYYY')
                                : null}
                        </Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export const MoneyCardFinancialSummary: React.FC<MoneyCardProps> = ({ data }) => {
    const route = useAppRoute();
    const goToDetails = useCallback(() => route(`/creators-list/${data.projectId}/dashboard/money/${data.assetCode}/edit-deal`), [
        data.projectId,
        data.assetCode,
        route,
    ]);

    return (
        <Card className={css.module} elevation={0} onClick={goToDetails}>
            <CardContent>
                <Grid container className={css.grid}>
                    <Grid item xs={1} className={css.gridItem}>
                        <Avatar alt={data.contractTitle} src={data.contactImage || ''} />
                    </Grid>
                    <Grid item xs={4} style={{ display: 'flex', alignItems: 'center' }}>
                        {data.contractTitle}
                    </Grid>
                    <Grid item xs={4} style={{ display: 'flex', alignItems: 'center' }}>
                        {data.contactNameContract}
                    </Grid>
                    <Grid item xs={3} style={{ display: 'flex', alignItems: 'center' }}>
                        ${data.invAmount}
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};
